import PatientStudies from './PatientStudies';

export default PatientStudies;
